import { MAX_WORKFLOW_LOG_CAPTURE_BYTES } from '@shared/workflow/maxWorkflowLogCaptureBytes.js';

// Tied to the per-run "Capture Full Run Logs" budget: step payloads within it stay searchable, while
// larger ones (the step that crosses the budget is stored whole) skip client-side filtering.
export const maxSearchableChars = MAX_WORKFLOW_LOG_CAPTURE_BYTES;

/**
 * Pre-serializes log data items for client-side search so each keystroke only scans strings.
 *
 * @param {*} data - The step response data (searchable only when it is an array)
 * @returns {Array<string>|null} - Lowercased serialized items, or null when the data is not
 *   an array or its combined serialized size exceeds maxSearchableChars (callers must then
 *   skip client-side filtering instead of blocking the main thread)
 */
const serializeSearchableData = (data) => {
  if (!Array.isArray(data)) {
    return null;
  }

  let totalChars = 0;
  const serialized = [];

  for (const item of data) {
    const text = JSON.stringify(item) || '';
    totalChars += text.length;

    if (totalChars > maxSearchableChars) {
      return null;
    }

    serialized.push(text.toLowerCase());
  }

  return serialized;
};

export default serializeSearchableData;
